<template>
  <f7-page @page:beforeout="beforeOut">
    <template v-if="itemExists">
      <f7-navbar :title="item.title" back-link="back" />
      <div style="padding-bottom: 50px;">
        <img v-if="item.coverImgUrl" id="image" :src="imgSrc" :style="{ height: imageWidth + 'px', width: imageWidth + 'px' }" alt="餐點圖片" />
        <img v-else id="image" src="@/assets/itemDefault.jpg" :style="{ height: imageWidth + 'px', width: imageWidth + 'px' }" alt="餐點圖片" />
        <f7-list accordion-list style="margin: 0px;">
          <question
            slot="list"
            v-for="(question, i) in item.allLevelQuestions"
            :key="`content-adjustment-${i}`"
            :itemObj="itemObj"
            :questionId="question.id"
            :focus="firstInvalidQuestionId === question.id" />
        </f7-list>
        <div v-if="item.allowSpecialRequests" @click="showSpecialRequestsPopup" id="special-request-wrapper">
          <div style="flex 1 1 auto; font-size: 16px; margin-left: 0px;">{{ $t(`contentAdjustment.specialRequests`) }}</div>
          <div id="special-request">
            <template v-if="itemObj.specialRequests">{{ itemObj.specialRequests }}</template>
            <span v-else style="color: #888888;">{{ $t(`contentAdjustment.pleaseEnterSpecialRequests`) }}</span>
          </div>
        </div>
      </div>
      <f7-button
        fill
        raised
        @click="confirm"
        style="position: fixed;
              left: 0px;
              bottom: 0px;
              width: 100%;
              height: 45px;
              line-height: 45px;
              z-index: 15;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;">{{ $t(`instruction.ok`) }}</f7-button>
    </template>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Question from '../components/menu-form/Question'

export default {
  name: 'ContentAdjustment',
  dependencies: ['ImageUrlBuilder', 'imageResolutions', 'CartElementBuilder'],
  data () {
    return {
      hasConfirmed: false,
      itemDefinitionId: this.fullItemIdPathParam.split('.')[0],
      itemInstanceId: this.fullItemIdPathParam.split('.')[1],
      windowWidth: 0,
      windowHeight: 0,
      imageWidth: 0,
      scale: 3
    }
  },
  props: {
    itemBucketPathParam: String,
    fullItemIdPathParam: String,
    edit: Boolean
  },
  computed: {
    ...mapState('itemModule', ['cart', 'favorites']),
    ...mapGetters(['storeId', 'currentMenu']),
    itemExists () {
      return this[this.itemBucketPathParam][this.itemDefinitionId] && this[this.itemBucketPathParam][this.itemDefinitionId][this.itemInstanceId]
    },
    itemObj () {
      return this[this.itemBucketPathParam][this.itemDefinitionId][this.itemInstanceId]
    },
    item () {
      return this.CartElementBuilder.buildItem(this.itemObj, this.currentMenu)
    },
    firstInvalidQuestionId () {
      const invalidQuestion = this.item.allLevelQuestions.find(q => !q.isValid)
      return invalidQuestion ? invalidQuestion.id : undefined
    },
    imgSrc () {
      const size = this.imageResolutions.find(s => this.imageWidth * window.devicePixelRatio < s) || this.imageResolutions[this.imageResolutions.length - 1]
      return this.ImageUrlBuilder[`url${size}`](this.item.coverImgUrl, this.storeId)
    }
  },
  created () {
    this.windowWidth = document.documentElement.clientWidth
    this.windowHeight = document.documentElement.clientHeight
    this.imageWidth = Math.min(this.windowHeight / this.scale, this.windowWidth)
  },
  methods: {
    ...mapActions('itemModule', ['removeItem']),
    formComponent: title => title.charAt(0).toUpperCase() + title.slice(1) + 'Element',
    showSpecialRequestsPopup () {
      this.$f7router.navigate(`/stores/${this.storeId}/items/${this.itemBucketPathParam}/${this.fullItemIdPathParam}/questions/special-requests-popup`)
    },
    confirm () {
      this.hasConfirmed = true
      this.$f7router.back()
    },
    beforeOut () {
      if (!this.edit && !this.hasConfirmed) {
        this.removeItem({
          itemBucket: 'cart',
          id: this.item.id,
          instanceId: this.item.instanceId
        })
      }
    }
  },
  components: {
    Question
  }
}
</script>

<style lang="scss" scoped>
#image {
  display: block;
  margin: 10px auto;
}

#special-request-wrapper {
  display: flex;
  flex-direction: column;
  text-align: left;
  color: black;
  margin-bottom: 60px;
  padding: 12px 16px;
}

#special-request {
  flex: 1 1 auto;
  margin: 10px 20px 20px;
  border: solid 1px #CAD0CC;
  border-radius: 5px;
  padding: 10px 15px;
  min-height: 40px;
  color: black;
  font-size: 14px;
  overflow-wrap: break-word;
}

#confirm-button {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 45px;
  line-height: 45px;
  z-index: 1;
}
</style>
